import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="page-not-found">
      <div className="grid h-16 w-16 place-items-center rounded-2xl bg-[#1C2640]"><Compass className="h-8 w-8 text-[#2DD4BF]" /></div>
      <h1 className="mt-6 font-display text-4xl font-bold text-[#F8FAFC]">404</h1>
      <p className="mt-2 max-w-md text-[#CBD5E1]">La pagina che cerchi non esiste o è stata spostata.</p>
      <Button asChild className="mt-6 bg-[#7C3AED] hover:bg-[#6D28D9]"><Link to="/">Torna alla home</Link></Button>
    </div>
  );
}
